/* eslint-disable max-params */
/* eslint-disable camelcase */
import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    ExternalAccountCreationInfo,
    ExternalAccountSnapshot,
} from '../../models/Banking';
import api from '../api';

const getExternalAccounts = (): Promise<ExternalAccountSnapshot[]> =>
    api.request<ExternalAccountSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/banking/external_account`,
    });

const createExternalAccount = (
    data: ExternalAccountCreationInfo
): Promise<ExternalAccountSnapshot> =>
    api.request<ExternalAccountSnapshot>({
        method: 'POST',
        action: 'BANKING_EXTERNAL_ACCOUNT_CREATION',
        url: `${getBackVersion()}/banking/external_account`,
        data: decamelizeKeys({ ...data, isOwnAccount: true }),
    });

const getExternalAccount = (
    externalAccountId: string
): Promise<ExternalAccountSnapshot> =>
    api.request<ExternalAccountSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/banking/external_account/${externalAccountId}`,
    });

export { getExternalAccounts, getExternalAccount, createExternalAccount };
